<template>
    <li
        class="collapsible"
        @click="isAccordionShown = !isAccordionShown"
    >
        <div>
            <span
                v-if="isAccordionShown"
                uk-icon="icon: triangle-down"
            />
            <span
                v-else
                uk-icon="icon: triangle-right"
            />
            {{ title }}
        </div>
        <div
            v-if="isAccordionShown"
            class="uk-accordion-content"
        >
            <transition
                name="fade"
                mode="out-in"
                appear
            >
                <slot>
                    <field-value-list
                        :list="list"
                    />
                </slot>
            </transition>
        </div>
    </li>
</template>

<script>
const FieldValueList = () => import("./FieldValueList");

export default {
    name: "RefundRequestDetailsCollapsibleSection",
    components: { FieldValueList },
    props: {
        title: {
            type: String,
            required: true
        },
        list: {
            type: [Array, Object],
            default: function () {
                return {};
            }
        }
    },
    data: function () {
        return {
            isAccordionShown: false
        }
        
    }
}
</script>

<style scoped>
    li {
        margin-bottom: 15px;
    }
    .collapsible {
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 10px 10px 10px 15px;
    }
</style>